import * as React from 'react';
import styled from 'styled-components';

export interface Props {
  width?: any;
  children: any;
  shouldFillMobile?: boolean;
  style?: React.CSSProperties;
  className?: string;
}

export class GridItem extends React.Component<Props> {
  render() {
    const { children, shouldFillMobile } = this.props;

    return (
      <Item
        className={this.props.className}
        shouldFillMobile={shouldFillMobile}
        style={{
          ...this.props.style,
        }}
      >
        {children}
      </Item>
    );
  }
}

const Item: any = styled.div`
  flex-basis: 33.3%;

  @media all and (max-width: 600px) {
    flex-basis: 50%;
  }

  &,
  &:focus {
    outline: none !important;
  }
`;
